import React, { Component } from 'react'
import { Collapse, Badge, IconButton, Grid } from '@material-ui/core'
import { connect } from 'react-redux'
import { isEqual, isEmpty } from 'lodash'
import { injectIntl } from 'react-intl'
import { List } from 'immutable'
import cn from 'classnames'
import { setProfileMnaFilters } from 'reducers/profile/reducer'
import { MNA_FILTERS, PROFILE_MNA_FILTERS } from 'constants/mnaFilters'
import Psfs from 'lib/psfs/Psfs'
import {
  fetchRegionList,
  fetchSiteGroupsList,
  fetchSiteList,
  setLocusGroupsLoaded,
  clearMnaStore,
  fetchSiteTypes,
  fetchLocusGroups,
} from 'reducers/monitorsAndAlerts/reducer'
import { ReactComponent as OpenFiltersIcon } from 'assets/img/open-filters.svg'
import { ReactComponent as ClearFiltersIcon } from 'assets/img/clear-filters.svg'
import { FilterComponent } from './FilterComponent'

class SiteFilters extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const prevCurrentSites = prevState.currentSites.toArray()
    const nextSiteList = nextProps.siteList.toArray()

    if (!(prevCurrentSites && prevCurrentSites.length > 0)) {
      return { currentSites: nextProps.siteList }
    }

    if (prevCurrentSites.length !== nextSiteList.length) {
      return { currentSites: prevState.currentSites }
    }

    return null
  }

  constructor(props) {
    super(props)
    this.state = {
      isFiltersOpen: false,
      dataLoaded: {},
      filterObj: {},
      currentSites: List([]),
      initialData: [],
      filtersToShow: [],
      filtersArr: this.initFilters(props, MNA_FILTERS),
      showBadge: false,
      setInitialData: false,
    }
  }

  componentDidMount() {
    const {
      fetchSiteTypes,
      fetchRegionList,
      fetchSiteGroupsList,
      licensee: { mnaFilters },
    } = this.props

    if (mnaFilters.includes('siteTypes')) {
      fetchSiteTypes()
    }

    if (mnaFilters.includes('regions')) {
      fetchRegionList()
    }

    if (mnaFilters.includes('siteGroups')) {
      const psfs = new Psfs()
      psfs.addFilter('visibleInUi', 1)
      fetchSiteGroupsList({ psfs })
    }
  }

  // eslint-disable-next-line max-statements
  componentDidUpdate(prevProps) {
    const {
      locusGroup,
      siteList,
      regions,
      siteTypes,
      siteGroups,
      licensee: { name, mnaFilters },
      setProfileMnaFilters,
      setLocusGroupsLoaded,
    } = this.props
    const {
      locusGroup: prevLocusGroup,
      regions: prevRegions,
      siteTypes: prevSiteTypes,
      siteGroups: prevSiteGroups,
      licensee: { name: prevName },
    } = prevProps
    const arrLocusGroup = locusGroup.toArray()
    const prevArrLocusGroup = prevLocusGroup.toArray()
    const arrSiteList = siteList.toArray()
    const arrRegions = regions.toArray()
    const prevArrRegions = prevRegions.toArray()
    const arrSiteTypes = siteTypes.toArray()
    const prevArrSiteTypes = prevSiteTypes.toArray()
    const arrSiteGroups = siteGroups.toArray()
    const prevArrSiteGroups = prevSiteGroups.toArray()
    const { dataLoaded, filtersToShow } = this.state
    const dataLoadedLength = Object.keys(dataLoaded).length

    if (mnaFilters.includes('locusGroups')) {
      if (isEmpty(arrLocusGroup) && !isEmpty(arrSiteList)) {
        this.fetchLocusGroups()
      }

      if (dataLoadedLength === 0 && !dataLoaded.locusGroups) {
        this.fetchSitesByFilter([])
      }

      if (!isEqual(arrLocusGroup, prevArrLocusGroup)) {
        const newArr = this.changeByProp('locusGroups', locusGroup.toArray())
        const updatedArr = this.applyDataFromProfileFilters(
          'locusGroups',
          newArr,
        )
        this.setFilterData('locusGroups', updatedArr)
      }
    }

    if (
      !isEqual(arrRegions, prevArrRegions) &&
      mnaFilters.includes('regions')
    ) {
      const newArr = this.changeByProp('regions', arrRegions)
      const updatedArr = this.applyDataFromProfileFilters('regions', newArr)
      this.setFilterData('regions', updatedArr)
    }

    if (
      !isEqual(arrSiteTypes, prevArrSiteTypes) &&
      mnaFilters.includes('siteTypes')
    ) {
      const newArr = this.changeByProp('siteTypes', arrSiteTypes)
      const updatedArr = this.applyDataFromProfileFilters('siteTypes', newArr)
      this.setFilterData('siteTypes', updatedArr)
    }

    if (
      !isEqual(arrSiteGroups, prevArrSiteGroups) &&
      mnaFilters.includes('siteGroups')
    ) {
      const newArr = this.changeByProp('siteGroups', siteGroups.toArray())
      const updatedArr = this.applyDataFromProfileFilters('siteGroups', newArr)
      this.setFilterData('siteGroups', updatedArr)
    }

    if (
      dataLoadedLength > 0 &&
      dataLoadedLength === mnaFilters.length &&
      isEmpty(filtersToShow)
    ) {
      const data = this.getFiltersData()
      setLocusGroupsLoaded(true)
      this.fetchSitesByFilter(data)
    }

    if (name !== prevName) {
      this.setState({ showBadge: false })
      setProfileMnaFilters({ ...PROFILE_MNA_FILTERS })
    }
  }

  componentWillUnmount() {
    const { clearMnaStore } = this.props

    clearMnaStore()
  }

  getActiveFilters = ({ activeFilters }) => ({
    regions: activeFilters.get('regions').toArray(),
    siteTypes: activeFilters.get('siteTypes').toArray(),
    siteGroups: activeFilters.get('siteGroups').toArray(),
    locusGroups: activeFilters.get('locusGroups').toArray(),
  })

  initFilters(props, filters) {
    const activeFilters = this.getActiveFilters(props)

    return filters.map(filter => {
      const newFilter = { ...filter }
      const { storeName } = newFilter

      if (Object.prototype.hasOwnProperty.call(activeFilters, storeName)) {
        newFilter.value = activeFilters[storeName]
      }

      return newFilter
    })
  }

  applyDataFromProfileFilters(field, arr) {
    const profileFilters = this.checkProfileMnaFilters()
    const isDataExist = Object.values(profileFilters).some(
      item => Array.isArray(item) && item.length > 0,
    )
    let filteredArr = []

    if (isDataExist) {
      filteredArr = arr.map(item => {
        if (item.storeName === field) {
          const filteredArr = item.value.filter(
            elem =>
              profileFilters[field] &&
              profileFilters[field].some(id => elem.id === id),
          )

          return {
            ...item,
            value: filteredArr,
          }
        }

        return item
      })

      return filteredArr
    }

    return arr
  }

  checkProfileMnaFilters() {
    const mnaFilters = this.getActiveFilters(this.props)
    const keys = Object.keys(mnaFilters)
    let checkFilters

    if (keys && keys.length > 0) {
      checkFilters = Object.entries(mnaFilters).reduce((total, item) => {
        const result = { ...total }
        const [filterName, idsData] = item
        result[filterName] = idsData

        return result
      }, {})
    }

    return checkFilters
  }

  existInLicenseeFilters(arr, licenseeMnaFilters) {
    return arr.filter(item =>
      licenseeMnaFilters.some(elem => item.storeName === elem),
    )
  }

  showBadge() {
    const { filtersArr } = this.state
    const {
      licensee: { mnaFilters },
    } = this.props
    const filteredArr = this.existInLicenseeFilters(filtersArr, mnaFilters)
    const showBadge = filteredArr.some(
      ({ value, data }) => value.length !== data.length,
    )

    this.setState({ showBadge })
  }

  getFiltersData() {
    const { filtersArr } = this.state
    const {
      licensee: { mnaFilters },
    } = this.props

    let data = []
    if (mnaFilters && mnaFilters.length > 0) {
      data = filtersArr.filter(item =>
        mnaFilters.some(elem => item.storeName === elem),
      )
    }

    this.setState({ filtersToShow: data })

    return data.reduce((acc, { value, storeName }) => {
      if (value && value.length > 0) {
        const ids = value.map(elem => elem.id)
        acc[storeName] = ids
      }

      return acc
    }, {})
  }

  setFilterData(field, newArrData) {
    const { dataLoaded, filtersArr } = this.state
    const { setLocusGroupsLoaded } = this.props

    this.setState(
      {
        dataLoaded: {
          ...dataLoaded,
          [field]: true,
        },
        filtersArr: newArrData,
      },
      () => {
        const updatedArr = filtersArr.map(item => ({
          ...item,
          value: item.data,
        }))

        this.setState(
          {
            initialData: updatedArr,
          },
          this.showBadge,
        )

        if (field === 'locusGroups' && dataLoaded[field]) {
          const data = this.getFiltersData()
          setLocusGroupsLoaded(true)
          this.fetchSitesByFilter(data)
        }
      },
    )
  }

  fetchLocusGroups() {
    const { currentSites } = this.state
    const { fetchLocusGroups } = this.props
    const psfs = new Psfs()
    const sites = currentSites.toArray()

    if (sites && sites.length > 0) {
      const sitesIds = sites.map(item => item.id)
      psfs.addFilter('site', sitesIds, 'in').addFilter('visibleInUi', 1)
      fetchLocusGroups({ psfs })
    }
  }

  changeByProp(prop, data) {
    const { filtersArr } = this.state

    return filtersArr.map(item => {
      if (item.storeName === prop) {
        return {
          ...item,
          data,
          value: data,
        }
      }

      return item
    })
  }

  handleFilterChange = (value, storeName) => {
    const { setProfileMnaFilters } = this.props
    const { filtersArr, filterObj } = this.state
    let idsData
    const newArr = filtersArr.map(item => {
      if (item.storeName === storeName) {
        return {
          ...item,
          value,
        }
      }

      return item
    })

    if (!isEqual(filtersArr, newArr)) {
      this.setState(
        {
          filterObj: {
            ...filterObj,
            [storeName]: value,
          },
          filtersArr: newArr,
        },
        () => {
          idsData = this.filterSites()
          this.showBadge()

          if (storeName !== 'locusGroups') {
            this.fetchSitesByFilter(idsData)
          }

          setProfileMnaFilters({ ...idsData })
        },
      )
    }
  }

  fetchSitesByFilter(data) {
    const { filtersArr } = this.state
    const { fetchSiteList } = this.props
    const { data: groupData, value: groupValue } =
      filtersArr.find(filter => filter.storeName === 'siteGroups') || {}
    const psfs = new Psfs()

    Object.keys(data).forEach(item => {
      if (data[item] && data[item].length > 0) {
        if (item === 'siteTypes') {
          psfs.addFilter('type', data[item], 'in')
        } else if (
          item === 'siteGroups' &&
          groupData &&
          groupValue &&
          groupData.length !== groupValue.length
        ) {
          psfs.addFilter('group', data[item], 'in')
        } else if (item === 'regions') {
          psfs.addFilter('region', data[item], 'in')
        }
      }
    })

    psfs.addFilter('active', 1).addFilter('visibleInUi', 1)

    fetchSiteList({ psfs })
  }

  filterSites() {
    const { filtersArr } = this.state
    const {
      licensee: { mnaFilters },
    } = this.props

    let filtersToShow = []
    if (mnaFilters && mnaFilters.length > 0) {
      filtersToShow = filtersArr.filter(item =>
        mnaFilters.some(elem => item.storeName === elem),
      )
    }

    const keys = Object.keys(filtersToShow)

    return keys.reduce((result, item) => {
      const total = { ...result }
      const { storeName } = filtersToShow[item]
      const ids = filtersToShow[item].value.map(elem => elem.id)
      total[storeName] = ids

      return total
    }, {})
  }

  handleClick = () => {
    const { isFiltersOpen } = this.state

    this.setState({ isFiltersOpen: !isFiltersOpen })
  }

  resetFilters = () => {
    const { filtersArr } = this.state
    const isFiltersChanged = filtersArr.some(
      ({ value, data }) => value.length !== data.length,
    )

    if (isFiltersChanged) {
      this.setState(
        prevState => ({
          filtersArr: prevState.initialData,
          setInitialData: true,
        }),
        () => {
          const data = this.getFiltersData()
          this.fetchSitesByFilter(data)
          this.setState({ showBadge: false })
        },
      )
    }
  }

  handleSetInitialData = flag => {
    this.setState({ setInitialData: flag })
  }

  renderFilters() {
    const { filtersArr, setInitialData } = this.state
    const {
      intl: { formatMessage },
      licensee: { mnaFilters },
    } = this.props
    let filtersToShow = []

    if (mnaFilters && mnaFilters.length > 0) {
      filtersToShow = filtersArr.filter(item =>
        mnaFilters.some(elem => item.storeName === elem),
      )
    }

    return filtersToShow.map(filterData => (
      <Grid key={filterData.id} item>
        <FilterComponent
          {...filterData}
          disableUnderline
          allSelectedExistInList
          handleFilterChange={this.handleFilterChange}
          formatMessage={formatMessage}
          setInitialData={setInitialData}
          handleSetInitialData={this.handleSetInitialData}
        />
      </Grid>
    ))
  }

  renderCollapseBlock() {
    const { isFiltersOpen } = this.state

    return (
      <Collapse in={isFiltersOpen}>
        <Grid container classes={{ root: 'filter-wrap' }}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              {this.renderFilters()}
            </Grid>
          </Grid>
        </Grid>
      </Collapse>
    )
  }

  render() {
    const { isFiltersOpen, showBadge } = this.state

    return (
      <>
        <Badge variant="dot" invisible={!showBadge}>
          <IconButton
            className={cn('icon-btn', { open: isFiltersOpen })}
            onClick={this.handleClick}>
            <OpenFiltersIcon />
          </IconButton>
        </Badge>
        <IconButton classes={{ root: 'icon-btn' }} onClick={this.resetFilters}>
          <ClearFiltersIcon />
        </IconButton>
        {this.renderCollapseBlock()}
      </>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['monitorsAndAlerts', 'activeSite']),
    activeLocus: state.getIn(['monitorsAndAlerts', 'activeLocus']),
    siteTypes: state.getIn(['monitorsAndAlerts', 'siteTypes']),
    activeFilters: state.getIn(['profile', 'mnaFilters']),
    licensee: state.getIn(['profile', 'profile', 'licensee']),
    siteList: state.getIn(['monitorsAndAlerts', 'siteList']),
    siteGroups: state.getIn(['monitorsAndAlerts', 'siteGroupsList']),
    regions: state.getIn(['monitorsAndAlerts', 'regionList']),
    locusGroup: state.getIn(['monitorsAndAlerts', 'locusGroupList']),
    isLocusGroupsLoaded: state.getIn([
      'monitorsAndAlerts',
      'isLocusGroupsLoaded',
    ]),
    filtersInitialData: state.getIn([
      'monitorsAndAlerts',
      'filtersInitialData',
    ]),
  }),
  {
    fetchSiteTypes,
    fetchRegionList,
    fetchSiteGroupsList,
    fetchSiteList,
    setProfileMnaFilters,
    setLocusGroupsLoaded,
    clearMnaStore,
    fetchLocusGroups,
  },
)(injectIntl(SiteFilters))
